import React, { Component } from "react";
import "./screentwo.css";
import image1 from "..//..//images/screenone.jpg";
import image2 from "..//..//images/screentwo.jpg";
import image3 from "..//..//images/screenfour.jpg";
import image4 from "..//..//images/screenfive.jpg";

const pics = [image1, image2, image4, image3];

export default class Screentwo extends Component {
  constructor(props) {
    super(props);
    const idxStart = 0;
    this.state = {
      index: idxStart,
      next: this.getNextIndex(idxStart),
      move: false,
    };
  }

  getNextIndex(idx) {
    if (idx >= pics.length - 1) {
      return 0;
    }
    return idx + 1;
  }

  setIndexes(idx) {
    this.setState({
      index: idx,
      next: this.getNextIndex(idx),
    });
  }
  componentDidMount() {
    setInterval(() => {
      // on
      this.setState({
        move: true,
      });
      // off
      setTimeout(() => {
        this.setState({
          move: false,
        });
        this.setIndexes(this.getNextIndex(this.state.index));
      }, 500); // same delay as in the css transition here
    }, 5000);
  }
  render() {
    let message;
    if (this.state.index === 0) {
      message =
        "Welcome to Lafema Systems Limited, your one stop car tracking systems";
    }
    if (this.state.index === 1) {
      message = "We provide the very best of the best car tracking systems ";
    }
    if (this.state.index === 2) {
      message = "We connect you to your car from any location";
    }
    if (this.state.index === 3) {
      message = "We focus on Monitoring what matters to you the most";
    }

    const move = this.state.move ? "move" : "";
    if (this.state.move) {
    }
    return (
      <div className="screen2">
        <div className="mask">
          <div className="pic-wrapper">
            <div className={`current pic ${move}`}>
              <div className="picandword">
                <img src={pics[this.state.index]} alt="" />
                <div>
                  <h1>{message}</h1>
                </div>
              </div>
            </div>
            <div className={`next pic ${move}`}>
              <div className="picandword">
                <img src={pics[this.state.next]} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
